import { render, staticRenderFns } from "./Dribs.vue?vue&type=template&id=2b5a1ef8&scoped=true"
import script from "./Dribs.vue?vue&type=script&lang=js"
export * from "./Dribs.vue?vue&type=script&lang=js"
import style0 from "./Dribs.vue?vue&type=style&index=0&id=2b5a1ef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5a1ef8",
  null
  
)

export default component.exports